module.exports = __webpack_public_path__ + "img/logo-om.0793b8db.webp";